// extracted by mini-css-extract-plugin
module.exports = {"container":"B2BSteps_container__mLTij","stepsContainer":"B2BSteps_stepsContainer__EfnAJ","title":"B2BSteps_title___vjPw","byLine":"B2BSteps_byLine__x84Q_"};